import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'elipsis'
})
export class ElipsisPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer) { }

  transform(value: any,serachvalue:any) {
    if (!value) {
      return value;
    }
	const valueStr = this.escapeStr(value) + ''; // Ensure numeric values are converted to strings

	 if(!serachvalue) {
            return valueStr;
        }
	 	let valueStr1 = valueStr.replace(new RegExp(serachvalue, "gi"), match => {
            return '<span style="background-color: yellow !important;">' + match + '</span>';
        });
		return this.sanitized.bypassSecurityTrustHtml(valueStr1);
  }
  escapeStr(valueOfFile :any) {
    if(valueOfFile.length > 20){
      var firstString = valueOfFile.split(".") [(valueOfFile.split(".")).length - 1];
      var secondString= valueOfFile.slice(0,20-(firstString.length))+"..."+firstString;
      return secondString;
    }
    return valueOfFile;
  }

}
